<div class="content-selector-dialog" [class.loading]="loading()">
  <div class="top">
    <div class="header">
      <div class="left">
        <i class="{{icon}} w-20"></i>
        <span>{{title}}</span>
      </div>
      <div class="right">
        <button trgButton color="dialogClose" round
                (click)="cancelClick()"
                class="w-25 h-25">
          <i class="fal fa-times i-12"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="middle">
    <div class="topbar">
      <div class="d-flex align-items-center">
        @if (loading() && !categories().length)
        {
        <span class="mr-20">
          <loading-rect size="180px 25px"></loading-rect>
        </span>
        <span class="mr-20">
          <loading-rect size="180px 25px"></loading-rect>
        </span>
        <span class="mr-20">
          <loading-rect size="180px 25px"></loading-rect>
        </span>
        }
        @for (c of categories(); track c.id)
        {
        <span class="mr-20">
          @if (loading())
          {
          <loading-rect size="160px 25px"></loading-rect>
          }
          <trg-checkbox [hidden]="loading()"
                        appearance="circle"
                        size="small"
                        [value]="c.selected()"
                        (valueChange)="selectCategory(c)">
            {{c.title}} ({{c.visibleItems()}})
          </trg-checkbox>
        </span>
        }
      </div>
      <div class="d-flex align-items-center">
        <label class="mr-6">View:</label>
        <button trgButton color="primary" class="trg-toggle h-26 lh-26 fs-12"
                [class.in]="favouriteOnly()"
                (click)="favouriteOnly.set(!favouriteOnly())"
                [disabled]="loading()">
          <i class="fas fa-star i-9 i-circle"></i>
          <span>Starred</span>
        </button>
        <div class="filter-vr"></div>
        <label class="mr-6">Find:</label>
        <input type="text"
               class="trg-outline h-26 lh-26 fs-12"
               placeholder="Enter Text"
               [readonly]="loading()"
               [(ngModel)]="filter" />
      </div>
    </div>
    <div class="content">
      <div class="content-col item-group-list">
        <div class="content-col-top">
          <div class="content-col-inner">Category</div>
        </div>
        <div class="content-col-bottom">
          <div class="content-col-inner">
            @if (loading())
            {
            <div class="item-group-list-item">
              <loading-rect size="100% 25px"></loading-rect>
            </div>
            <div class="item-group-list-item">
              <loading-rect size="100% 25px"></loading-rect>
            </div>
            <div class="item-group-list-item">
              <loading-rect size="100% 25px"></loading-rect>
            </div>
            <div class="item-group-list-item">
              <loading-rect size="100% 25px"></loading-rect>
            </div>
            }
            @for (g of itemGroups(); track g.id)
            {
            <div class="item-group-list-item"
                 [class.selected]="g.selected()"
                 [hidden]="!g.draw()"
                 (click)="selectItemGroup(g)"
                 [title]="g.name">
              <span>{{g.name}}</span>
            </div>
            }
          </div>
        </div>
      </div>
      <div class="content-col item-list">
        <div class="content-col-top">
          <div class="content-col-inner">Insight</div>
        </div>
        <div class="content-col-bottom">
          <div class="content-col-inner">
            @if (loading())
            {
            <div class="item">
              <loading-rect size="100% 25px"></loading-rect>
            </div>
            <div class="item">
              <loading-rect size="100% 25px"></loading-rect>
            </div>
            <div class="item">
              <loading-rect size="100% 25px"></loading-rect>
            </div>
            <div class="item">
              <loading-rect size="100% 25px"></loading-rect>
            </div>
            }
            @for (i of items(); track i.key)
            {
            @let visible = i.draw() && i.visible();

            <div class="item"
                 [class.selected]="i.selected()"
                 [hidden]="!visible"
                 (click)="selectItem(i)"
                 [title]="i.title">
              @if (i.selected()) {
              <div hidden #selectedItemDiv></div>
              }
              <span class="item-text">
                @if (filtering()) {
                <text-highlight [text]="i.title"
                                [pattern]="filterPatterns()"
                                (matched)="i.hideByFiltering.set(!$event)"></text-highlight>
                }
                @else {
                <span>{{i.title}}</span>
                }
              </span>
              @if (i.icon) {
              <img [hidden]="i.selected()"
                   class="item-icon"
                   [src]="i.icon.default"
                   alt=""
                   [title]="i.icon.title" />

              <img [hidden]="!i.selected()"
                   class="item-icon"
                   [src]="i.icon.selected"
                   alt=""
                   [title]="i.icon.title" />
              }
            </div>
            }
          </div>
        </div>
      </div>
      <div class="content-col selected-item">
        <div class="content-col-top">
          <div class="content-col-inner">Preview &amp; Description</div>
          <div class="suggest-item">
            @if (suggestOption) {
            @if (suggestOption.action) {
            <button trgButton color="white" class="c-blue" (click)="suggestOption.action()">
              <i class="{{suggestOption.icon}}"></i>
              <span>{{suggestOption.title}}</span>
            </button>
            }
            @else {
            <a href="{{suggestOption.url}}" class="c-blue">
              <i class="{{suggestOption.icon}} mr-2"></i>
              <span>{{suggestOption.title}}</span>
            </a>
            }
            }
          </div>
        </div>
        <div class="content-col-bottom">
          <div class="content-col-inner">
            @if (loading())
            {
            <div class="selected-item-content">
              <div class="d-flex justify-content-between w-100p h-100p" style="gap: 15px">
                <loading-rect size="50% 50%"></loading-rect>
                <div class="d-flex" style="flex-direction: column; width: 50%">
                  <loading-rect size="100% 25px" class="mb-15"></loading-rect>
                  <loading-rect size="100% 25px" class="mb-15"></loading-rect>
                  <loading-rect size="100% 25px" class="mb-15"></loading-rect>
                  <loading-rect size="100% 25px" class="mb-15"></loading-rect>
                  <loading-rect size="100% 25px" class="mb-15"></loading-rect>
                  <loading-rect size="100% 25px" class="mb-15"></loading-rect>
                </div>
              </div>
            </div>
            }
            @for (i of items(); track i.key)
            {
            <div class="selected-item-content"
                 [hidden]="!i.selected()">
              @if (i.viewed()) {
              <ng-container *ngComponentOutlet="itemPreview; inputs: { item: i, visible: i.selected() }"></ng-container>
              }
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="bottom">
    <div class="left"></div>
    <div class="right">
      <button trgButton [color]="cancelButton.color"
              (click)="cancelClick()"
              class="min-w-80 mr-8"
              [disabled]="loading()">
        @if (cancelButton.icon) { <i class="{{cancelButton.icon}} w-20"></i> }
        <span>{{cancelButton.text}}</span>
      </button>

      <button trgButton [color]="acceptButton.color"
              (click)="acceptClick()"
              class="min-w-80"
              [disabled]="loading() || !canAccept() || selectedItemDisabled()">
        @if (acceptButton.icon) { <i class="{{acceptButton.icon}} w-20"></i> }
        <span>{{acceptButton.text}}</span>
      </button>
    </div>
  </div>
</div>